
export default function Divider() {
  return <div className="Divider" />;
}
